// services/partners/UpdatePartner.ts

import api from "@/services/api";
import { PartnerDetailsType } from "@/types/partner/Partner";

const sanitizeString = (value?: string | null): string =>
  value ? value.toString().trim() : "";

const sanitizeOptionalString = (value?: string | null): string | null => {
  if (value === null || value === undefined) {
    return null;
  }
  const trimmed = value.toString().trim();
  return trimmed.length ? trimmed : null;
};

class UpdatePartner {
  execute = async (partner: PartnerDetailsType) => {
    const payload: any = {
      name: sanitizeString(partner.name),
      tax: Number(partner.tax),
      phone: sanitizeString(partner.phone),
      nickname: sanitizeOptionalString(partner.nickname || partner.nickName),
      email: sanitizeString(partner.email),
      document: sanitizeString(partner.document),
      pixkey: sanitizeOptionalString(partner.pixkey),
      typeCompany: partner.typeCompany,
      cnaeCode: sanitizeString(partner.cnaeCode || "1") || "1",
      categoryId: partner.categoryId,
      address: {
        street: sanitizeString(partner.address.street),
        state: sanitizeString(partner.address.state),
        number: sanitizeOptionalString(partner.address.addressNumber),
        addressNumber: sanitizeOptionalString(partner.address.addressNumber),
        neighborhood: sanitizeString(partner.address.neighborhood),
        complement: sanitizeOptionalString(partner.address.complement),
        zipCode: sanitizeString(partner.address.zipCode),
        city: sanitizeString(partner.address.cityName),
        cityName: sanitizeString(partner.address.cityName),
        ibge: sanitizeString(partner.address.ibge),
      },
      user: {
        name: sanitizeString(partner.user.name),
        motherName: sanitizeOptionalString(partner.user.motherName),
        nickname: sanitizeOptionalString(partner.user.nickname),
        birthdate: sanitizeOptionalString(partner.user.birthdate),
        email: sanitizeString(partner.user.email),
        phone: sanitizeString(partner.user.phone),
        document: sanitizeString(partner.user.document),
        password: sanitizeOptionalString(partner.user.password),
      },
      associates: partner.associates,
      businessHours: partner.businessHours,
      digitalAccountNumber: sanitizeOptionalString(partner.digitalAccountNumber),
      digitalAccountDocument: sanitizeOptionalString(
        partner.digitalAccountDocument
      ),
      description: partner.description || undefined,
      whatsapp: sanitizeOptionalString(partner.whatsapp) || undefined,
      instagram: sanitizeOptionalString(partner.instagram) || undefined,
    };

    if (Array.isArray(partner.images) && partner.images.length > 0) {
      payload.images = partner.images;
    }

    const partnerData = await api().put("/partner", payload);

    return partnerData;
  };
}

export { UpdatePartner };
